import { Component, Input, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-simple-bottom-sheet',
  templateUrl: './simple-bottom-sheet.component.html',
  styleUrls: ['./simple-bottom-sheet.component.css'],
  imports: [ MatBottomSheetModule]
})
export class SimpleBottomSheetComponent implements OnInit {

  @Input() sheetText: string;

  constructor(private bottomSheetRef: MatBottomSheetRef<SimpleBottomSheetComponent>, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
  }

  public ngOnInit(): void {
  }


  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
